module.exports = __webpack_public_path__ + "img/SupportIcon.7090a218.svg";